import {cloneDeep, isEmpty, isObject, isUndefined, has, merge} from 'lodash';
import {ApiService} from '@nl/ui';
import Logger from '@nl/logger';
import {getCookie, delCookie} from '@nl/neu';
import {event, EVENT_TYPES} from './event';
import {getCategoryPurchase} from './getCategoryPurchase';

class Auth {
	constructor() {
		this.nlaaui = null;
		this.isDomestic = true;
		this.init = this.init.bind(this);
		this.getInstance = this.getInstance.bind(this);
		this.checkAuth = this.checkAuth.bind(this);
		this.checkProgram = this.checkProgram.bind(this);
		this.initPackMap = this.initPackMap.bind(this);
		this.getUserSubs = this.getUserSubs.bind(this);
		this.updateUser = this.updateUser.bind(this);
		this.setUserFreePreview = this.setUserFreePreview.bind(this);
		this.signIn = this.signIn.bind(this);
		this.opinLogout = this.opinLogout.bind(this);
		this.dtcLogout = this.dtcLogout.bind(this);
		this.tveLogout = this.tveLogout.bind(this);
		this.updateNBANewletters = this.updateNBANewletters.bind(this);
		this.updateNBAShare = this.updateNBAShare.bind(this);
		this.updateNBAEmail = this.updateNBAEmail.bind(this);
		this.updateNBAPassword = this.updateNBAPassword.bind(this);
		this.updateNBAPersonal = this.updateNBAPersonal.bind(this);
		this.showChangePasswordModal = this.showChangePasswordModal.bind(this);
	}

	async init(isDomestic = false, useAPI = false,
						 userUpdateHandler, setInitializedHandler, setLocaleLanguage, config, setHideScore) {
		if (this.nlaaui) {
			return;
		}
		const owner = this;
		owner.isDomestic = isDomestic;
		owner.hasInit = false;
		owner.hasDTCInit = false;
		owner.isNBALinked = false;
		owner.isOPINLinked = false;
		owner.finalUser = {opin: false, nba: false, dtc: false, tve: false};
		this.userUpdateHandler = userUpdateHandler;
		this.setInitializedHandler = setInitializedHandler;
		this.setLocaleLanguage = setLocaleLanguage;
		this.setHideScore = setHideScore;
		const {
			LOC_SERVER,
			PACK_MAP,
			teams,
			content,
			CATEGORY_PURCHASE_TYPE_ID,
			NBA_TV_CATEGORY_SEO_NAMES,
			LP_CATEGORY_SEO_NAMES,
			LPP_CATEGORY_SEO_NAMES,
		} = config;
		this.loc_server = LOC_SERVER;
		this.CATEGORY_PURCHASE_TYPE_ID = CATEGORY_PURCHASE_TYPE_ID;
		this.NBA_TV_CATEGORY_SEO_NAMES = NBA_TV_CATEGORY_SEO_NAMES;
		this.LP_CATEGORY_SEO_NAMES = LP_CATEGORY_SEO_NAMES;
		this.LPP_CATEGORY_SEO_NAMES = LPP_CATEGORY_SEO_NAMES;
		this.cameras = has(content, 'cameras') ? cloneDeep(content.cameras) : [];

		this.nlaaui = ApiService();

		if (!this.nlaaui) {
			return;
		}

		/* Init final User Status */
		if (isDomestic) {
			this.finalUser.opin = true;
		} else {
			this.finalUser.tve = true;
		}

		/* Set cache user status to Store */
		if (has(this.nlaaui, 'nllanguage')) {
			this.setLocaleLanguage(this.nlaaui.nllanguage);
		}

		if (has(this.nlaaui, 'nlhidescores')) {
			this.setHideScore && this.setHideScore(this.nlaaui.nlhidescores);
		}

		/* Add Event Listener */
		this.nlaaui.addEventListener((eventType, payload) => {
			// Debug log
			Object.keys(owner.nlaaui.EventTypes).forEach((key) => {
				if (owner.nlaaui.EventTypes[key] === eventType) {
					Logger.info(`nlaaui event : ${key}`, owner.nlaaui);
				}
			});
			if (!owner.hasDTCInit && (eventType === owner.nlaaui.EventTypes.DTC_AUTHENTICATED
					|| eventType === owner.nlaaui.EventTypes.DTC_NOT_AUTHENTICATED)) {
				owner.hasInitialized();
				owner.hasDTCInit = true;
			}
			// Get g_nlaaui by store.
			if (!owner.hasInit) {
				const {dtc, tve, opin, nba} = owner.nlaaui;
				owner.updateUser({dtc, tve, opin, nba});
				Logger.info('nlaaui event get cache ', owner.nlaaui);
				owner.hasInit = true;
			}
			switch (eventType) {
				case owner.nlaaui.EventTypes.DTC_AUTHENTICATED:
					event.trigger(EVENT_TYPES.DTC_AUTHENTICATED, owner.nlaaui);
					break;
				case owner.nlaaui.EventTypes.TVE_AUTHENTICATED:
					break;
				case owner.nlaaui.EventTypes.TVE_PREAUTHORIZED:
					owner.handlePreAuthorized(true);
					break;
				case owner.nlaaui.EventTypes.TVE_NOT_PREAUTHORIZED:
					owner.handlePreAuthorized(false);
					break;
				case owner.nlaaui.EventTypes.DTC_METADATA:
					owner.handleDTCProfile();
					break;
				case owner.nlaaui.EventTypes.DTC_NOT_AUTHENTICATED:
					owner.handleDTCLogout(eventType);
					break;
				case owner.nlaaui.EventTypes.DTC_AUTHORIZED:
					event.trigger(EVENT_TYPES.DTC_AUTHORIZED, owner.nlaaui);
					break;
				case owner.nlaaui.EventTypes.NBA_AUTHENTICATED:
					event.trigger(EVENT_TYPES.NBA_AUTHENTICATED, owner.nlaaui);
					break;
				case owner.nlaaui.EventTypes.NBA_DTC_AUTHENTICATED:
					owner.isNBALinked = true;
					owner.handleDTCProfile();
					event.trigger(EVENT_TYPES.NBA_DTC_AUTHENTICATED, owner.nlaaui);
					break;
				case owner.nlaaui.EventTypes.NBA_DTC_NOT_AUTHENTICATED:
					owner.handleNBAProfile();
					event.trigger(EVENT_TYPES.NBA_DTC_NOT_AUTHENTICATED, owner.nlaaui);
					break;
				case owner.nlaaui.EventTypes.NBA_NOT_AUTHENTICATED:
					owner.handleNBALogout();
					event.trigger(EVENT_TYPES.NBA_NOT_AUTHENTICATED, owner.nlaaui);
					break;
				case owner.nlaaui.EventTypes.NBA_METADATA:
					owner.handleNBAProfile();
					event.trigger(EVENT_TYPES.NBA_AUTHENTICATED_METADATA, owner.nlaaui);
					break;
				case owner.nlaaui.EventTypes.OPIN_AUTHENTICATED:
					break;
				case owner.nlaaui.EventTypes.OPIN_NOT_AUTHENTICATED:
					owner.handleOpinLogout();
					break;
				case owner.nlaaui.EventTypes.TVE_NOT_AUTHENTICATED:
					owner.handelTVELogout(eventType);
					break;
				case owner.nlaaui.EventTypes.OPIN_DTC_AUTHENTICATED:
					owner.isOPINLinked = true;
					owner.handleDTCProfile();
					break;
				case owner.nlaaui.EventTypes.OPIN_DTC_NOT_AUTHENTICATED:
					owner.handleOpinLogin();
					break;
				case owner.nlaaui.EventTypes.TVE_ENTITLED:
					owner.handleIsEntitled(true, payload);
					break;
				case owner.nlaaui.EventTypes.DTC_ENTITLED:
					owner.handleIsEntitled(false, payload);
					break;
				case owner.nlaaui.EventTypes.NOT_ENTITLED:
					owner.handelNotEntitled(payload);
					break;
				case owner.nlaaui.EventTypes.TVE_METADATA:
					owner.handleTVEProfile(payload);
					break;
				case owner.nlaaui.EventTypes.TVE_AUTHORIZED:
					// payload: [mvpdToken,[params1,params2,...]]
					if (payload && payload.length > 1 && payload[1] && payload[1].length > 1
							&& payload[1][1]) {
						payload[1][1](payload[1][0], payload[0]);
					}
					break;
				case owner.nlaaui.EventTypes.MESSAGE:
					if (payload[0] === 'nllanguage') {
						this.setLocaleLanguage(payload[1]);
					} else if (payload[0] === 'nlhidescores') {
						this.setHideScore(payload[1]);
					} else if (payload[0] === 'pwResetModalClosed') {
						event.trigger(EVENT_TYPES.RESET_PASSWORD_MODAL_CLOSE);
					}
					break;
				default:
					break;
			}
		});

		/* Add ACM listener */
		event.on(EVENT_TYPES.PLAYER_ACM_CALLBACK, () => {
			tveLogout();
		});

		// Get PACK_MAP Config
		this.initPackMap(PACK_MAP, teams);
	}

	getInstance() {
		return this.nlaaui;
	}

	hasInitialized() {
		this.setInitializedHandler && this.setInitializedHandler(true);
	}

	completeUserStatus(userType) {
		const that = this;
		if (!this.finalUser[userType]) {
			Logger.info('completeUserStatus :', userType);
			this.finalUser[userType] = true;
			const {opin, nba, dtc, tve} = this.finalUser;
			if (opin && nba && dtc && tve) {
				event.trigger(EVENT_TYPES.USER_STATUS_COMPLETED, this.nlaaui);
				Logger.info('Trigger USER_STATUS_COMPLETED', this.nlaaui);
				that.checkResetPasswordPage();
			}
		} else {
			// Todo: user status changed
		}
	}

	checkResetPasswordPage() {
		const that = this;
		const codeName = 'nlcode';
		const code = getCookie(codeName);
		if (code) {
			delCookie(codeName, '.nba.com');
			setTimeout(() => {
				that.nlaaui && that.nlaaui.createPasswordResetModal(code);
			}, 500);
		}
	}

	/* Add Team Choice Subs to PACK_MAP */
	initPackMap(packMap, teams) {
		const pack = {...packMap};
		const TEAM_CODE = [];
		for (const code in teams) {
			if (teams[code].isintl === undefined && teams[code].conference !== '') {
				TEAM_CODE.push(code);
			}
		}

		// For Team Choice Packages
		TEAM_CODE.forEach((item) => {
			pack[`BTC${item}`] = '4';
			pack[`BTC${item}MONTHLY`] = '4';
			pack[`NBATP-${item}`] = '4';
			pack[`BTCUS${item}`] = '4';
			pack[`BTCUS${item}MONTHLY`] = '4';
		});
		this.packMap = pack;
	}

	/* Get dtc user package skus and tve user resourceIds */
	getUserSubs(user, isFreePreview) {
		let retSubs = null;
		let userStatusFinal = false;
		if (this.isDomestic) {
			if (has(user, 'dtc') && has(user, 'dtc.loggedIn') && has(user, 'tve') && has(user, 'tve.loggedIn') && !isUndefined(isFreePreview)) {
				userStatusFinal = true;
			}
		} else if (has(user, 'dtc') && has(user, 'dtc.loggedIn') && has(user, 'opin') && has(user, 'opin.loggedIn') && !isUndefined(isFreePreview)) {
			userStatusFinal = true;
		}

		if (userStatusFinal) {
			retSubs = '';
			if (user && user.tve && user.tve.loggedIn && user.tve.preauthorizedResourceIds) {
				retSubs = user.tve.preauthorizedResourceIds.join(',');
			}

			if (user.opin.loggedIn && user.opin.metadata && user.opin.metadata.opinSku) {
				const opinskuMap = {
					opin_league_pass: 'BLPPMONTHLY,BLPP',
					opin_game_choice: 'BLPCMONTHLY,BLPC',
					opin_game_choice_basic: 'BLPBMONTHLY,BLPB',
					opin_vivo_basic: 'BVIVO',
				};
				const opinsku = user.opin.metadata.opinSku;
				if (opinskuMap[opinsku]) {
					retSubs = !retSubs ? opinskuMap[opinsku] : `${retSubs},${opinskuMap[opinsku]}`;
				}
			}

			if (user && user.dtc && user.dtc.loggedIn && user.dtc.subs) {
				if (!retSubs) {
					retSubs = user.dtc.subs;
				} else {
					retSubs = `${retSubs},${user.dtc.subs}`;
				}
			}

			if (user && user.dtc && user.dtc.loggedIn && user.dtc.metadata.isVIP) {
				retSubs = 'VIP';
			}

			if (user && user.dtc && user.dtc.loggedIn && isFreePreview) {
				const freePreviewSubs = this.isDomestic ? 'BLPPUSPREVIEW' : 'BLPPPREVIEW';
				if (!retSubs) {
					retSubs = freePreviewSubs;
				} else {
					retSubs = `${retSubs},${freePreviewSubs}`;
				}
			}
		}
		return retSubs;
	}

	/* Check auth by PACK_MAP */
	checkProgram(programItem, type, userSubs) {
		if (isEmpty(programItem)) {
			return false;
		}

		if (userSubs === 'VIP') {
			return true;
		}

		const packMap = {...this.packMap};
		let purchase = '';
		let hasAccess = false;
		if (type === 'video' || type === 'program') {
			if (has(programItem, 'customPurchaseTypeId')) {
				purchase = programItem.customPurchaseTypeId === 'nbatv' ? 'live' : programItem.customPurchaseTypeId;
			} else {
				purchase = programItem.purchaseTypeId ? programItem.purchaseTypeId : 0;
			}
			hasAccess = purchase === 0;
		} else if (type === 'channellive' || type === 'channeldvr') {
			purchase = type.replace('channel', '');
		} else if (type === 'epg') {
			if (has(programItem, 'noAccess')) {
				hasAccess = !programItem.noAccess;
			}
			if (has(programItem.status, 'isLive') && programItem.status.isLive) {
				purchase = 'live';
			} else if (has(programItem.status, 'isArchive') && programItem.status.isArchive) {
				purchase = 'dvr';
			} else { // upcoming
				purchase = 'live';
			}
		} else if (type === 'package') {
			purchase = programItem.toLowerCase();
			hasAccess = false;
		} else {
			purchase = programItem.purchaseTypeId ? programItem.purchaseTypeId : 0;
			hasAccess = purchase === 0;
		}
		const entitled = ('' || userSubs).split(',').map((sub) => {
			const access = packMap[sub] && packMap[sub].indexOf(purchase) > -1;
			return access;
		});
		return hasAccess || entitled.indexOf(true) > -1;
	}

	/* Check auth by detail call */
	checkAuth(program, programType, userSubs) {
		Logger.info('checkAuth: in auth.js', program, programType, userSubs);
		this.currentCheckingProgram = (isObject(program) ? program.seoName : program).toLowerCase();
		return new Promise((resolve) => {
			const checkingProgram = cloneDeep(program);

			let type = null;
			let gameType = null;
			switch (programType) {
				case 'video':
					type = this.nlaaui.ProgramTypes.VOD;
					break;
				case 'channellive':
					type = this.nlaaui.ProgramTypes.CHANNEL;
					break;
				case 'channeldvr':
					type = this.nlaaui.ProgramTypes.CHANNEL;
					break;
				case 'channel':
					type = this.nlaaui.ProgramTypes.CHANNEL;
					break;
				case 'game':
					type = this.nlaaui.ProgramTypes.GAME_SEO;
					gameType = this.nlaaui.ProgramTypes.GAME;
					if (isObject(program) && has(program, 'isGame') && program.isGame === 'false') {
						type = this.nlaaui.ProgramTypes.EVENT_SEO;
						gameType = this.nlaaui.ProgramTypes.EVENT;
					}
					break;
				case 'event':
				case 'preevent':
					type = this.nlaaui.ProgramTypes.EVENT_SEO;
					gameType = this.nlaaui.ProgramTypes.EVENT;
					break;
				default:
					break;
			}
			let seoName = typeof (checkingProgram) === 'object' ? checkingProgram.seoName : checkingProgram;
			let pArgs = null;
			let caData = null;
			if (programType === 'game' || programType === 'event' || programType === 'preevent') {
				if (isUndefined(seoName)) {
					seoName = checkingProgram.extId;
					type = gameType;
				}
				caData = checkingProgram.caData || [];
				pArgs = {cameras: this.cameras, caData};
				if (has(checkingProgram, 'isAudio') && checkingProgram.isAudio === true) {
					pArgs.isAudio = true;
				}
			}
			event.off('AuthCompleted').on('AuthCompleted', (res) => {
				const ret = cloneDeep(res);
				if (ret.program && programType !== 'channel' && ret.program.bundlePurchases) {
					delete ret.program.bundlePurchases;
				}
				if (ret.program && ret.program.gamePurchases) {
					delete ret.program.gamePurchases;
				}
				if (ret.program && ret.program.relatedCategory) {
					delete ret.program.relatedCategory;
				}
				if (ret.program && ret.program.relatedKeyword) {
					delete ret.program.relatedKeyword;
				}
				if (ret.program && this.currentCheckingProgram === ret.program.seoName.toLowerCase() && !has(ret, 'code')) {
					const checkedProgram = merge({}, ret.program, {noAccess: !ret.hasAccess});
					if (programType === 'channel') {
						const dvrAccess = checkProgram(program, 'channeldvr', userSubs);
						resolve({...checkedProgram, noAccessDvr: !dvrAccess}, caData);
					} else if ((programType === 'game' || programType === 'event') && checkedProgram.isCancelled) {
						event.trigger(EVENT_TYPES.GAME_MODAL_CLOSE, {...checkedProgram, caData});
					} else {
						resolve({...checkedProgram, caData});
					}
				} else {
					resolve({...ret});
				}
			});

			if (programType === 'preevent') {
				Logger.info('checkAuth :isEntitled');
				this.nlaaui.isEntitled(seoName, pArgs, type);
			} else if ((programType === 'game' || programType === 'event') && isObject(checkingProgram)) {
				const modal = document.getElementById('nlaauiModal');
				Logger.info('modal', modal);
				if (!modal) {
					if (has(checkingProgram, 'preevent')) {
						delete checkingProgram.isCancelled;
						pArgs.game = checkingProgram;
					}
					Logger.info('checkAuth :checkEntitlement, pArgs', pArgs);
					this.nlaaui.checkEntitlement(seoName, pArgs, type);
				}
			} else {
				Logger.info('checkAuth :checkEntitlement, pArgs', pArgs);
				this.nlaaui.checkEntitlement(seoName, pArgs, type);
			}
		});
	}

	signIn(type) {
		if (isUndefined(type)) {
			if (this.isDomestic) {
				this.nlaaui.nbaLogin();
			} else {
				this.nlaaui.opinLogin();
			}
		} else {
			switch (type) {
				case 'tve':
					this.nlaaui.tveLogin();
					break;
				case 'dtc':
					this.nlaaui.dtcLogin();
					break;
				case 'nba':
					this.nlaaui.nbaLogin();
					break;
				default:
					break;
			}
		}
	}

	opinLogout() {
		this.nlaaui.opinLogout();
	}

	dtcLogout() {
		this.nlaaui.dtcLogout();
	}

	tveLogout() {
		this.nlaaui.tveLogout();
	}

	handleDTCProfile() {
		const {dtc, nba, opin} = this.nlaaui;
		const newUser = {
			dtc: {
				...dtc,
				subs: (dtc.metadata.subs2 || []).join(','),
			},
		};
		if (this.isNBALinked) {
			Logger.info('nlaaui: isNBALinked');
			newUser.nba = nba;
			this.isNBALinked = false;
		}
		if (this.isOPINLinked) {
			Logger.info('nlaaui: isOPINLinked');
			newUser.opin = opin;
			this.isOPINLinked = false;
		}
		Logger.info('nlaaui: DTC Profile newUser', newUser);
		this.updateUser(newUser);
	}

	handleDTCLogout() {
		this.updateUser({dtc: this.nlaaui.dtc});
	}

	handleNBAProfile() {
		this.updateUser({nba: this.nlaaui.nba});
	}

	handleNBALogout() {
		this.updateUser({nba: this.nlaaui.nba});
	}

	handleTVEProfile() {
		if (!isUndefined(this.nlaaui.tve.preauthorizedResourceIds) && this.nlaaui.tve.metadata.guid) {
			this.updateUser({tve: this.nlaaui.tve});
		}
	}

	handlePreAuthorized(isAuthorized) {
		if (!isUndefined(this.nlaaui.tve.preauthorizedResourceIds) && this.nlaaui.tve.metadata.guid) {
			if (isAuthorized) {
				this.updateUser({tve: this.nlaaui.tve});
			} else {
				this.updateUser({tve: {...this.nlaaui.tve, preauthorizedResourceIds: []}});
			}
		}
	}

	handelTVELogout() {
		this.updateUser({tve: this.nlaaui.tve});
	}

	handleOpinLogin() {
		this.updateUser({opin: this.nlaaui.opin});
	}

	handleOpinLogout() {
		this.updateUser({opin: this.nlaaui.opin});
	}

	getRequestResourceId(purchase, resourceIds) {
		let ret = '';
		for (const item of resourceIds) {
			const accessPurchase = (this.packMap[item] || '').split(',');
			if (accessPurchase.indexOf(purchase) > -1
					|| accessPurchase.indexOf(purchase.toString()) > -1) {
				ret = item;
				break;
			}
		}
		return ret;
	}

	handleIsEntitled(isTVE, payLoad) {
		const camera = (payLoad[3] === this.nlaaui.ProgramTypes.EVENT || payLoad[3] === this.nlaaui.ProgramTypes.GAME) && payLoad[1] && has(payLoad[1], 'id') ? payLoad[1].id : null;
		if (isEmpty(payLoad[2]) || has(payLoad[2], 'code')
				|| (Object.keys(payLoad[2]).length === 1 && Object.keys(payLoad[2])[0] === 'seoName')) {
			event.trigger('AuthCompleted', {
				code: payLoad[2].code || 'Failed',
				message: 'Data Error',
				...payLoad[2],
			});
			return;
		}
		if (isTVE) { // Get short media token
			let purchase = '';
			const requestResourceIds = this.nlaaui.tve.preauthorizedResourceIds
					? this.nlaaui.tve.preauthorizedResourceIds : [];
			if (payLoad[3] === this.nlaaui.ProgramTypes.CHANNEL) {
				purchase = 'live';
			} else if (payLoad[3] === this.nlaaui.ProgramTypes.VOD) {
				purchase = payLoad[2].purchaseTypeId ? payLoad[2].purchaseTypeId : '';
				if (this.CATEGORY_PURCHASE_TYPE_ID && payLoad[2].purchaseTypeId
						&& payLoad[2].purchaseTypeId.toString() === this.CATEGORY_PURCHASE_TYPE_ID.toString()) {
					purchase = getCategoryPurchase(
							this.CATEGORY_PURCHASE_TYPE_ID,
							payLoad[2].categories || [],
							this.NBA_TV_CATEGORY_SEO_NAMES,
							this.LP_CATEGORY_SEO_NAMES,
							this.LPP_CATEGORY_SEO_NAMES,
					);
					purchase = purchase === 'nbatv' ? 'live' : purchase;
				}
			} else if (payLoad[3] === this.nlaaui.ProgramTypes.GAME || payLoad[3] === this.nlaaui
					.ProgramTypes.EVENT) {
				if (has(payLoad[2], 'season')) {
					purchase = `season${payLoad[2].season}`;
				}
			}
			const requestResourceId = this.getRequestResourceId(purchase, requestResourceIds);

			if (requestResourceId === '') {
				event.trigger('AuthCompleted', {hasAccess: false, program: {...payLoad[2]}});
			} else {
				this.nlaaui.authorize(requestResourceId, (resourceId, mvpdToken) => {
					const ret = {
						hasAccess: true,
						program: {
							...payLoad[2],
							publishPointParams: {
								aprid: requestResourceId,
								aptoken: encodeURIComponent(mvpdToken),
							},
							resourceId: requestResourceId,
						},
					};
					if (camera) {
						ret.program.publishPointParams.cam = camera;
						ret.program.selectedCamera = payLoad[1] || {};
					}
					event.trigger('AuthCompleted', ret);
				});
			}
		} else {
			const ret = {hasAccess: true, program: {...payLoad[2], publishPointParams: {}}};
			if (camera) {
				ret.program.publishPointParams.cam = camera;
				ret.program.selectedCamera = payLoad[1] || {};
			}
			event.trigger('AuthCompleted', ret);
		}
	}

	handelNotEntitled(payLoad) {
		if (isEmpty(payLoad[2]) || has(payLoad[2], 'code')) {
			event.trigger('AuthCompleted', {
				code: payLoad[2].code || 'Failed',
				message: 'Data Error',
			});
			return;
		}
		const ret = {hasAccess: false, program: {...payLoad[2]}};
		if (payLoad[4] && payLoad[4] === 'X') {
			ret.program.isCancelled = true;
		}
		event.trigger('AuthCompleted', ret);
	}

	updateUser(user) {
		const newUser = merge({}, user);
		if (has(user, 'opin') && has(user.opin, 'partners')) {
			delete newUser.opin.partners;
		}
		const {opin, nba, dtc, tve} = newUser;
		if (isUndefined(opin) || isUndefined(nba) || isUndefined(dtc) || isUndefined(tve)) {
			if (!isUndefined(opin)) {
				this.completeUserStatus('opin');
			}
			if (!isUndefined(nba)) {
				this.completeUserStatus('nba');
			}
			if (!isUndefined(dtc)) {
				this.completeUserStatus('dtc');
			}
			if (!isUndefined(tve)) {
				this.completeUserStatus('tve');
			}
		}
		this.userUpdateHandler && this.userUpdateHandler(newUser);
	}

	setUserFreePreview(isFreePreviewUser) {
		this.userUpdateHandler && this.userUpdateHandler({
			isFreePreview: isFreePreviewUser,
		});
		if (this.isFreePreview === true && isFreePreviewUser === false) {
			this.nlaaui.authorize();
		}
		this.isFreePreview = isFreePreviewUser;
	}

	updateNBANewletters(newletters, callback) {
		Logger.info('newletters', newletters);
		this.nlaaui.getNBAClient().updateNewsletters(newletters)
				.then((result) => callback && callback(result));
	}

	updateNBAShare(share, callback) {
		const profile = {
			governance: {
				emailCommunicationConsent: share,
				emailCommunicationConsentTimestamp: new Date().toISOString(),
			},
		};
		this.nlaaui.getNBAClient().updateProfile(profile)
				.then((result) => callback && callback(result));
	}

	updateNBAEmail(newEmail, callback) {
		this.nlaaui.getNBAClient().updateProfile({email: newEmail})
				.then((result) => callback && callback(result));
	}

	showChangePasswordModal() {
		this.nlaaui && this.nlaaui.createChangePasswordModal();
	}

	updateNBAPassword(pCurrentPassword, pNewPassword, pConfirmNewPassword, callback) {
		this.nlaaui.getNBAClient().updatePassword(pCurrentPassword, pNewPassword, pConfirmNewPassword)
				.then((result) => callback && callback(result));
	}

	updateNBAPersonal(user, callback) {
		const {userName, country, zip} = user;
		this.nlaaui.getNBAClient().updateProfile({
			...userName,
			billingAddress: {
				...country,
				...zip,
			},
		}).then((result) => callback && callback(result));
	}
}

const auth = new Auth();
export const {
	init, getUserSubs, checkProgram, checkAuth, signIn, setUserFreePreview, opinLogout,
	tveLogout, dtcLogout, updateNBANewletters, updateNBAShare, updateNBAEmail,
	updateNBAPassword, updateNBAPersonal, showChangePasswordModal,
} = auth;
export default auth.getInstance();
